import React from 'react'
import ProductCounter from '../ProductCounter/ProductCounter';
import './shopping.css'
import Style from './ShoppingList.module.css'
import {errorToast, succToast} from '../../Toast/Toast'
import { UpdateProductCountInBasket } from '../../Api/BarestServices';
import { separate } from '../../Seprate/Seprate';

const ShoppingList = (props) => {
    const CountHandler=(e)=>{
        let IdList={
            supplier_id:props.supplierId,
            product_id:props.List.id,
            count:e
        }
        UpdateProductCountInBasket(IdList,(res)=>{
            // if(props.List.count>props.List.max_count){
            //     errorToast(` ${props.List.name} در انبار موجود نیست `)
            // }else{
                if(res.status===1)
                {
                    succToast('با موفقیت بروزرسانی شد')
                    props.onclickforce()
                }
                else{
                    errorToast(res.message)
                }
            // }
        })
    }
   
    return (
            <li className={Style.ShoppingList} >
                <p className={props.HideCounter? Style.WidthHolder : null}> {props.List.name}  <span className={props.HideCounter ? null:Style.hideSpan }>({props.Count})</span> </p>
                <div className={props.HideCounter? Style.HideCountHolder : Style.CounterHolder }>
                    <ProductCounter maxCount={props.List.max_count} CountProduct={props.List.count} GetCount={e=>CountHandler(e)}/>
                </div>
                <div className={Style.PriceList}><strong >{separate(props.List.count*(props.List.off_price>0?props.List.off_price:props.List.price))}<span>تومان</span></strong></div>
            </li>
    )
}
export default ShoppingList
